import React, { useState } from "react";
import { useStyles } from "./skills.styles";
import TitlePart from "../../../components/TitlePart/TitlePart";
import { my_skills } from "../../../data/Skills";

function Skills() {
  const [opened, setOpened] = useState(false);
  const handle_switch = () => {
    setOpened(!opened);
  };

  const styles = useStyles();
  return (
    <div className={styles.main} id="Skills">
      <TitlePart num={"03."}>Skills</TitlePart>

      <div className="works">

        <h2>⚡ Key Strengths</h2>
        <div className="strength-card">
          <img className="strength-gift" align="right" width="90px" height="90px" alt="side_sticker" src="https://media.giphy.com/media/TEnXkcsHrP4YedChhA/giphy.gif" />
          {my_skills.strengths.map((item, index) => {
            return (
              <StrengthsCard
                key={index}
                item={item}
                orient={index % 2 === 0 ? "ltr" : "rtl"}
              />
            );
          })}
        </div>

        <h2>⚡ Languages and Tools</h2>
        <div className="tool-card">
          {my_skills.tools.map((item, index) => {
            return (
              <ToolsCard
                key={index}
                item={item}
                orient={index % 2 === 0 ? "ltr" : "rtl"}
              />
            );
          })}
        </div>

      </div>

    </div>
  );
}

const StrengthsCard = ({ item }) => {
  return (
    <div>
      <p>• {item.strength}</p>
    </div>
  );
};

const ToolsCard = ({ item }) => {
  return (
    <div>
      <img src={item.image_url} height="40" alt="Tool logo" />
      <h3>{item.description}</h3>
    </div>
  );
};

export default Skills;
